module.exports = __webpack_public_path__ + "media/yir-short2.9e33ebae.mp4";